import growthbook from './growthbook';

export default {
  install(Vue) {
    Vue.prototype.$growthbook = growthbook;
  }
};
